import type { Resource } from '../../';
export const footer_emailForm_submit: Resource = {"default":">"};
